import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator, signOut } from "firebase/auth";

const firebaseConfig = JSON.parse(atob(process.env.REACT_APP_FIREBASE_CONFIG));

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// initialize authentication
const auth = getAuth(app);

if (process.env.NODE_ENV === 'development') {
    connectAuthEmulator(auth, process.env.REACT_APP_EMULATOR_HOST, { disableWarnings: false });
}

export { auth };